(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  class SeLooks extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.se-looks__track');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-look-step]');
        if (!button || !this.track) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: this.track.clientWidth * Number(button.dataset.lookStep),
          behavior: reduce ? 'auto' : 'smooth',
        });
      });
    }
  }

  if (!customElements.get('se-looks')) customElements.define('se-looks', SeLooks);

  } catch(e) { console.error(e); }
})();
})();
